import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MarkdownPipe } from '../../../shared';
import { CvDialogParams } from './cv-dialog.params';

@Component({
  selector: 'app-cv-dialog',
  imports: [MarkdownPipe, MatButtonModule, MatCheckboxModule, MatDialogModule],
  templateUrl: './cv-dialog.component.html',
  styleUrl: './cv-dialog.component.scss'
})
export class CvDialogComponent {
  //#region Protected Fields --------------------------------------------------
  protected readonly params: CvDialogParams;
  protected appendSkillSet: boolean;
  protected appendProjectList: boolean;
  protected calculatedUrl: string;
  //#endregion

  //#region Constructor & C° --------------------------------------------------
  public constructor(@Inject(MAT_DIALOG_DATA) params: CvDialogParams) {
    this.params = params;
    this.appendSkillSet = false;
    this.appendProjectList = false;
    this.calculatedUrl = this.calculateUrl();
  }
  //#endregion

  //#region UI-Triggers -------------------------------------------------------
  protected updateSkillSet(checked: boolean): void {
    this.appendSkillSet = checked;
    this.calculatedUrl = this.calculateUrl();
  }

  protected updateProjectList(checked: boolean): void {
    this.appendProjectList = checked;
    this.calculatedUrl = this.calculateUrl();
  }
  //#endregion

  //#region Auxiliary Methods -------------------------------------------------
  private calculateUrl(): string {
    let result = this.params.url;
    result += `?language=${this.params.language}`;
    if (this.appendSkillSet) {
      result += '&skills=true';
    }
    if (this.appendProjectList) {
      result += '&projects=true';
    }
    result += `&brand=${this.params.brand}`;
    return result;
  }
  //#endregion
}
